/**
 * Designed  & Developed by Faisal Nadaf
 * Contact: faisalfnadaf@gmail.com
 *
 * @format
 */

import { ThemeProvider } from "@/components/theme-provider";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";

import LoadingScreen from "@/components/LoadingScreen";
import ScrollToTop from "@/components/ScrollToTop";
import LandingPage from "@/pages/LandingPage";
import Clientele from "@/pages/Clientele";
import WorldwideProjects from "@/pages/WorldwideProjects";
import ContactUs from "@/pages/ContactUs";
import OurStory from "./pages/About/OurStory";
import VisionMission from "./pages/About/VisionMission";
import Achievements from "./pages/About/Achievements";
import SocialInitiatives from "./pages/About/SocialInitiatives";
import FoundersMessage from "./pages/About/FoundersMessage";
import ManagementTeam from "./pages/About/ManagementTeam";
import Certifications from "./pages/About/Certifications";
import OilGas from "./pages/Industries/OilGas";
import Pharmaceutical from "./pages/Industries/Pharmaceutical";
import ChemicalProcessing from "./pages/Industries/ChemicalProcessing";
import PowerGeneration from "./pages/Industries/PowerGeneration";
import FoodBeverage from "./pages/Industries/FoodBeverage";
import MarineOffshore from "./pages/Industries/MarineOffshore";
import SteelMetallurgy from "./pages/Industries/SteelMetallurgy";
import CementIndustry from "./pages/Industries/CementIndustry";
import WaterTreatment from "./pages/Industries/WaterTreatment";
import RenewableEnergy from "./pages/Industries/RenewableEnergy";
import HVACSystems from "./pages/Industries/HVACSystems";
import AirCooledHeatExchangers from "./pages/Products/AirCooledHeatExchangers";
import WaterCooledAirCoolers from "./pages/Products/WaterCooledAirCoolers";
import DoublePipeHeatExchangers from "./pages/Products/DoublePipeHeatExchangers";
import Recuperators from "./pages/Products/Recuperators";
import ShellSubeHeatExchangers from "./pages/Products/ShellSubeHeatExchangers";
import DryCoolers from "./pages/Products/DryCoolers";
import Onan from "./pages/Products/Onan";
import DataCenter from "./pages/Industries/DataCenter";
import PlasticInjectionMolding from "./pages/Industries/PlasticInjectionMolding";
import ProcessIndustries from "./pages/Industries/ProcessIndustries";
import Gallery from "./pages/About/Gallery";

export default function App() {
	return (
		<ThemeProvider defaultTheme="system">
			<BrowserRouter>
				<ScrollToTop />
				<Routes>
					<Route
						path="/"
						element={<LandingPage />}
					/>
					<Route
						path="/clientele"
						element={<Clientele />}
					/>
					<Route
						path="/worldwide-projects"
						element={<WorldwideProjects />}
					/>
					<Route
						path="/contact-us"
						element={<ContactUs />}
					/>
					//ABOUT US SUB-PAGES
					<Route
						path="/our-story"
						element={<OurStory />}
					/>{" "}
					<Route
						path="/vision-mission"
						element={<VisionMission />}
					/>{" "}
					<Route
						path="/achievements"
						element={<Achievements />}
					/>{" "}
					<Route
						path="/social-initiatives"
						element={<SocialInitiatives />}
					/>{" "}
					<Route
						path="/founder-message"
						element={<FoundersMessage />}
					/>{" "}
					<Route
						path="/management-team"
						element={<ManagementTeam />}
					/>{" "}
					<Route
						path="/certifications"
						element={<Certifications />}
					/>{" "}
					<Route
						path="/gallery"
						element={<Gallery />}
					/>
					// INDUSTRIES
					<Route
						path="/industries/oil-gas"
						element={<OilGas />}
					/>
					<Route
						path="/industries/pharmaceutical"
						element={<Pharmaceutical />}
					/>
					<Route
						path="/industries/chemical-fertilizer"
						element={<ChemicalProcessing />}
					/>
					{/* legacy slug */}
					<Route
						path="/industries/chemical-processing"
						element={
							<Navigate
								to="/industries/chemical-fertilizer"
								replace
							/>
						}
					/>
					<Route
						path="/industries/power-generation"
						element={<PowerGeneration />}
					/>
					<Route
						path="/industries/food-beverage"
						element={<FoodBeverage />}
					/>
					<Route
						path="/industries/marine-offshore"
						element={<MarineOffshore />}
					/>
					<Route
						path="/industries/steel-metallurgy"
						element={<SteelMetallurgy />}
					/>
					<Route
						path="/industries/cement-industry"
						element={<CementIndustry />}
					/>
					<Route
						path="/industries/water-treatment"
						element={<WaterTreatment />}
					/>
					<Route
						path="/industries/renewable-energy"
						element={<RenewableEnergy />}
					/>
					<Route
						path="/industries/data-center"
						element={<DataCenter />}
					/>
					<Route
						path="/industries/plastic-injection-molding"
						element={<PlasticInjectionMolding />}
					/>
					<Route
						path="/industries/process-industries"
						element={<ProcessIndustries />}
					/>
					<Route
						path="/industries/hvac-systems"
						element={<HVACSystems />}
					/>
					{/* PRODUCTS PAGES */}
					<Route
						path="/products/air-cooled-heat-exchangers"
						element={<AirCooledHeatExchangers />}
					/>
					<Route
						path="/products/water-cooled-air-coolers"
						element={<WaterCooledAirCoolers />}
					/>
					<Route
						path="/products/double-pipe-heat-exchangers"
						element={<DoublePipeHeatExchangers />}
					/>
					<Route
						path="/products/recuperators"
						element={<Recuperators />}
					/>
					<Route
						path="/products/shell-tube-heat-exchangers"
						element={<ShellSubeHeatExchangers />}
					/>
					<Route
						path="/products/dry-coolers"
						element={<DryCoolers />}
					/>
					<Route
						path="/products/onan"
						element={<Onan />}
					/>
				</Routes>
			</BrowserRouter>
		</ThemeProvider>
	);
}
